import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/no-unused-prop-types */

/* eslint-disable react/static-property-placement */
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import callbacksMiddleware from '../middleware/callbacks';
import rootReducer from '../reducers';

var Context = /*#__PURE__*/function (_Component) {
  _inherits(Context, _Component);

  var _super = _createSuper(Context);

  function Context(props) {
    var _this;

    _classCallCheck(this, Context);

    _this = _super.call(this, props);
    var middleware = [thunkMiddleware, callbacksMiddleware(props)];
    _this.store = createStore(rootReducer, applyMiddleware.apply(void 0, middleware));
    return _this;
  }

  _createClass(Context, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Provider, {
        store: this.store
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(this.props.className)
      }, this.props.children));
    }
  }]);

  return Context;
}(Component);

_defineProperty(Context, "propTypes", {
  onModalClose: PropTypes.func,
  onTrolleyRequest: PropTypes.func,
  onSuccessfulRequest: PropTypes.func,
  onSelectProduct: PropTypes.func,
  onFetchRecommendationsCompleted: PropTypes.func,
  className: PropTypes.string
});

_defineProperty(Context, "defaultProps", {
  className: '',
  onModalClose: function onModalClose() {},
  onSuccessfulRequest: function onSuccessfulRequest() {},
  onTrolleyRequest: function onTrolleyRequest() {},
  onSelectProduct: function onSelectProduct() {},
  onFetchRecommendationsCompleted: function onFetchRecommendationsCompleted() {}
});

Context.displayName = 'Context';
export default Context;